export const rangeToLimitValidator = (props: {
  limitFrom: number | string | null | undefined;
  rangeTo?: number | string;
  isRequired?: boolean;
}) => {
  const { limitFrom, rangeTo, isRequired } = props;
  if (isRequired && !rangeTo) return false;
  if (!rangeTo || !limitFrom) return true;
  if (Number(rangeTo) < Number(limitFrom)) return false;
  return true;
};
